export default __webpack_public_path__ + "static/media/cake-sweets.abd36d1b.jpg";